import React from 'react';
import EvidenceStatusBadge from './EvidenceStatusBadge';

export type EvidenceStatus = 'UPLOADING' | 'UPLOADED' | 'PROCESSING' | 'PROCESSED' | 'FAILED';

export interface EvidenceCardProps {
  categoryLabel: string;
  filename: string;
  status: EvidenceStatus;
  statusLabel?: string;
}

const EvidenceCard: React.FC<EvidenceCardProps> = ({ categoryLabel, filename, status, statusLabel }) => {
  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-sm font-semibold text-gray-900">{categoryLabel}</div>
          <div className="text-xs text-gray-500 mt-1">{filename}</div>
        </div>
        <EvidenceStatusBadge status={status} labelOverride={statusLabel} />
      </div>
    </div>
  );
};

export default EvidenceCard;
